define('evicommon/search/search.field',['require','exports','module','backbone'],function(require, exports, module){
  var Backbone = require('backbone');

  var SearchField = Backbone.Model.extend({

    name: function() {
      return this.get('name');
    },

    displayName: function() {
      return this.get('displayName');
    },

    isBoolean: function() {
      return !!this.get('boolean') || !!this.get('bool');
    }

  });

  SearchField.Collection = Backbone.Collection.extend({

    model: SearchField

  });

  module.exports = SearchField;
});
